import React, { useState } from 'react';
import {DateWithModal} from '../../../_common/dateWithModal';
import countryTelData from 'country-telephone-data';
import parsePhoneNumber from 'libphonenumber-js';
import {RegexFields} from '../../../constants/utils/regexFields';
import contriesList from 'iso-3166-1-alpha-2';
import { PostalCityInput } from "../../../_common/postalCityInput";


export const PersonalInformationSection = ({ account, setAccount, dossierTypeOptions, steps}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const gender = { male: 'Male', female: 'Female' };

    return (
			<div className="block mt-4" id="PersonalInformationSection">
				<div className="card-header py-0 pr-0 pl-4" id="headingUserDossier" role="button">
					<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target="#accordionUserDossier" aria-expanded="true" aria-controls="accordionUserDossier">
						<h2 className="h3 font-weight-black my-auto">
							<i className={"eva eva-checkmark-circle-outline fs-4 align-middle mr-1 ml-n4" + (steps[1] === true ? " text-success" : "")}></i>
							<span className="align-middle">{account.type === dossierTypeOptions.anticipa ? "Renseignements personnels" : "Renseignements du défunt"}</span>
						</h2>
						<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-30" name="refPrincipal">
							<i className="eva eva-arrow-ios-downward-outline"></i>
						</button>
					</div>
					<hr className="mt-2 mb-0 border-gray" />
				</div>
				<div className="card-body pl-4 pr-0 collapse" id="accordionUserDossier" aria-labelledby="headingUserDossier" data-parent="#accordionCreateDossier">
					<form className="mt-2" noValidate>
						<h4 className="h4 text-uppercase text-secondary font-weight-bolder my-2 mb-0 sr-only visually-hidden">ETAT CIVIL*</h4>
						<div className="form-inline mb-3">
							<div className="custom-control custom-radio custom-control-inline mr-6">
								<input required type="radio" id="Madame" name="SexMadameMonsieur" className="custom-control-input" checked={account.gender === gender.female ? true : false} onChange={() => setAccount({ ...account, gender: gender.female })} />
								<label className="custom-control-label" htmlFor="Madame">
									Madame
								</label>
							</div>
							<div className="custom-control custom-radio custom-control-inline">
								<input type="radio" id="Monsieur" name="SexMadameMonsieur" className="custom-control-input" checked={account.gender === gender.male ? true : false} onChange={() => setAccount({ ...account, gender: gender.male })} />
								<label className="custom-control-label" htmlFor="Monsieur">
									Monsieur
								</label>
							</div>
							<div className={"invalid-feedback alert-danger alert"}>Veuillez choisir une option</div>
						</div>
						<div className="row gx-1">
							<div className="form-row col-xl">
								<div className="form-group col-md">
									<label className="h6 font-weight-bolder my-auto" htmlFor="Prenom">
										Prénom *
									</label>
									<input
										required
										type="text"
										className="form-control"
										id="Prenom"
										value={account.firstName}
										onInput={(e) => {
											e.preventDefault();
											setAccount({ ...account, firstName: e.target.value });
										}}
										pattern={RegexFields.nameWithoutNumbers}
									/>
								</div>
								<div className="form-group col-md">
									<label className="h6 font-weight-bolder my-auto" htmlFor="Nom">
										Nom *
									</label>
									<input
										required
										type="text"
										className="form-control"
										id="Nom"
										defaultValue={account.lastName}
										onInput={(e) => {
											e.preventDefault();
											setAccount({ ...account, lastName: e.target.value });
										}}
										pattern={RegexFields.nameWithoutNumbers}
									/>
								</div>
							</div>
							<div className="form-group col-12 col-md">
								<label className="h6 font-weight-bolder my-auto" htmlFor="naissance">
									Date de naissance *
								</label>
								<DateWithModal
									isRequired={true}
									selectedDate={account.birthDate}
									setSelectedDate={(d) => {
										setAccount({ ...account, birthDate: d });
									}}
								/>
							</div>
						</div>
						{account.type !== dossierTypeOptions.anticipa ? (
							""
						) : (
							<div className="row gx-1">
								<div className="form-group col-12 col-sm">
									<label className="h6 font-weight-bolder my-auto" htmlFor="email">
										Email *
									</label>
									<input
										required
										type="email"
										className="form-control"
										id="email"
										value={account.email}
										onChange={(event) => {
											setAccount({ ...account, email: event.target.value });
											document.getElementById("email").setCustomValidity("");
										}}
										pattern={RegexFields.email}
									/>
								</div>
								<div className="form-group col-12 col-sm">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"Telephone"}>
										Numéro de portable
									</label>
									<div className="input-group mb-0">
										<select
											className="custom-select rounded container-tiny mr-2"
											id={"phonecode"}
											tabIndex={-98}
											value={account.countryCode}
											onChange={(event) => {
												let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
												setAccount({ ...account, countryCode: event.target.value, phoneCountry: pc });
											}}>
											{countryTelData.allCountries.map((country, index) => {
												let dialCode = country.dialCode;
												return (
													<option key={index} value={dialCode}>
														{countries.getName(country.iso2, "fr", { select: "official" })} (+{dialCode})
													</option>
												);
											})}
										</select>
										<input
											type="tel"
											className="form-control rounded"
											id="phoneNumber"
											value={parsePhoneNumber(account.phoneNumber, account.phoneCountry) !== undefined ? parsePhoneNumber(account.phoneNumber, account.phoneCountry).formatNational() : account.phoneNumber}
											aria-describedby="telephoneHelpBlock"
											onChange={(e) => {
												setAccount({ ...account, phoneNumber: e.target.value });
												document.getElementById("phoneNumber").setCustomValidity("");
											}}
										/>
									</div>
								</div>
							</div>
						)}

						{account.type === dossierTypeOptions.serenita ? (
							""
						) : (
							<div className="row gx-1">
								<div className="form-group col-md">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"AdresseC"}>
										Adresse *
									</label>
									<input required type="text" className="form-control" id="AdresseC" value={account.address.addressLine1} onChange={(e) => setAccount({ ...account, address: { ...account.address, addressLine1: e.target.value } })} />
								</div>
								<div className="col-md form-row">
									<PostalCityInput
										postalCode={account.address.postalCode}
										city={account.address.city}
										onChange={(updatedAddress) => setAccount({ ...account, address: { ...account.address, postalCode: updatedAddress.postalCode, city: updatedAddress.city } })}
										hasWrapper={false}
										country={account.address.country}
										customClasses={{ city: "form-group col", postalCode: "form-group col" }}
									/>
									<div className="form-group col-12 col-sm col-xl">
										<label className="h6 font-weight-bolder my-auto" htmlFor="naturalite">
											Pays *
										</label>
										<select
											className="custom-select"
											id="naturalite"
											tabIndex={-98}
											value={account.address.country}
											onChange={(e) => {
												setAccount({ ...account, address: { ...account.address, country: e.target.value } });
											}}>
											{Object.keys(contriesList.getData()).map((country, index) => {
												return (
													<option key={index} value={country}>
														{countries.getName(country, "fr", { select: "official" })}
													</option>
												);
											})}
										</select>
									</div>
								</div>
							</div>
						)}
					</form>
				</div>
			</div>
		);
}